// @ts-nocheck

import React, { ChangeEventHandler, useCallback, useContext, useEffect } from "react";
import cn from "classnames";
import Skeleton from "react-loading-skeleton";

import { TextareaProps } from "./Textarea.props";
import Label from "../Label";
import FieldMessage from "../FieldMessage";

import globalFormStyles from "../global.formElements.module.scss";
import styles from "./Textarea.module.scss";

import { FormContext } from "../../Form";

/**
 * @deprecated Use `import { TextArea } from capitalrx-components-2.0/lib/forms` instead.
 */
const Textarea: React.FC<TextareaProps> = ({
  id,
  labelText,
  placeholder,
  onChange,
  tabIndex,
  disabled = false,
  inputClassName,
  containerClassName,
  helperText,
  name,
  validate,
  autocomplete = true,
  useAsterisk,
  rows,
  isLoading,
  defaultValue,
}: TextareaProps): JSX.Element => {
  const { formState, register, unregister } = useContext(FormContext);
  const { errors, isFormLoading } = formState;

  const hasErrors = disabled ? undefined : errors;
  const isInvalid = errors && !disabled ? Object.keys(errors)?.length && errors[name] : false;

  const hasValidation = disabled ? undefined : validate;
  const registerField = register(name, hasValidation);

  const inputContainerClasses = cn(styles["form-field-container"], { disabled: disabled }, containerClassName);
  const inputClasses = cn(styles["textarea"], inputClassName, { [styles["invalid-field"]]: isInvalid });


  const handleInputChange = useCallback(
    (ev: ChangeEventHandler<HTMLTextAreaElement>): void => {
      onChange && onChange(ev);
      registerField.onChange(ev);
    },
    [onChange],
  );

  // Removes validation requirements on a disabled field
  useEffect(() => {
    if (disabled) {
      unregister(name);
    }
  }, [disabled, name]);

  let component = null;

  if (isLoading || isFormLoading) {
    component = <Skeleton height={80} />;
  } else {
    component = (
      <div className={globalFormStyles["field-wrapper"]}>
        <textarea
          {...registerField}
          aria-invalid={isInvalid ? "true" : "false"}
          aria-label={labelText}
          id={id}
          defaultValue={defaultValue}
          data-testid={`test__${id}`}
          placeholder={placeholder}
          tabIndex={tabIndex}
          disabled={disabled}
          onChange={(e) => handleInputChange(e)}
          className={inputClasses}
          autoComplete={autocomplete ? "on" : "off"}
          rows={rows}
        />
      </div>
    );
  }

  return (
    <div className={inputContainerClasses}>
      {labelText && (
        <Label id={id} label={labelText} disabled={disabled} isLoading={isLoading} validate={hasValidation} useAsterisk={useAsterisk} />
      )}
      {component}
      <FieldMessage id={id} helperText={helperText} errors={hasErrors} name={name} isLoading={isLoading} />
    </div>
  );
};

/**
 * @deprecated
 */
export default Textarea;
